var allBanners = document.querySelectorAll('.banner');
var allBannerOverlays = document.querySelectorAll('.banner--overlay');

if (allBanners && allBanners.length > 0) {
    allBanners.forEach((banner) => {
        var parent = banner.closest('section');
        if (parent != null) {
            parent.style.background = 'none';
        }
    })
}

if (allBannerOverlays && allBannerOverlays.length > 0) {
    allBannerOverlays.forEach((banner) => {
        var parent = banner.closest('section');
        if (parent != null) {
            parent.style.background = 'none';
        }
    })
}